import { Routes } from '@angular/router';
import { autorizacaoGuard } from '@cei-ufg/ngx-cei-seguranca';
import { autenticacaoGuard } from '@cei-ufg/ngx-cei-sso-client';
import {
  ACESSO_FERRAMENTAS_COLABORADOR_CEI,
  ACESSO_PORTAL,
  ADMINISTRADORES_GERAIS_ENTIDADES,
  ADMINISTRAR_TODAS_ENTIDADES,
  CADASTRAR_ENTIDADES,
  EDITAR_PROJETOS,
  EDITORES_PROJETOS,
  GESTAO_PROJETOS,
  GESTORES_PROJETOS,
  GRUPO_ACESSO_PUBLICO_PORTAL,
  GRUPO_COLABORADORES_CEI,
  VISUALIZAR_TODAS_ENTIDADES,
} from './constants/apps-permissions';
import { PortalLayoutComponent } from './layout/portal-layout/portal-layout.component';

const portalAccessData = {
  ceiPermissoes: [ACESSO_PORTAL],
  ceiGrupos: [GRUPO_ACESSO_PUBLICO_PORTAL],
};

/** Rotas do portal que exigem permissão de acesso ao CEI Apps. */
const rotaProtegidaPortal = {
  canActivate: [autorizacaoGuard],
  data: portalAccessData,
};

/** Rotas de erro e wildcard não exigem autorização RBAC. */
const rotaSemAutorizacao = {
  data: { ceiAuthorize: false },
};

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('@cei-ufg/ngx-cei-sso-client').then((m) => m.RedirectComponent),
  },
  {
    path: '',
    canActivate: [autenticacaoGuard],
    component: PortalLayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        ...rotaProtegidaPortal,
        loadComponent: () =>
          import('./components/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'pessoas',
        ...rotaProtegidaPortal,
        loadComponent: () =>
          import('./components/pessoas/pessoas.component').then((m) => m.PessoasComponent),
      },
      {
        path: 'pessoas/novo',
        ...rotaProtegidaPortal,
        loadComponent: () =>
          import('./components/pessoas/pessoa-form.component').then((m) => m.PessoaFormComponent),
      },
      {
        path: 'pessoas/me/atualizar',
        ...rotaProtegidaPortal,
        loadComponent: () =>
          import('./components/pessoas/pessoa-form.component').then((m) => m.PessoaFormComponent),
      },
      {
        path: 'editar-entidade',
        ...rotaProtegidaPortal,
        loadComponent: () =>
          import('./components/entidade/entidade-edit.component').then((m) => m.EntidadeEditComponent),
      },
      {
        path: 'editar-entidade/membros/:pessoaId/acesso',
        ...rotaProtegidaPortal,
        loadComponent: () =>
          import('./components/entidade/membro-acesso/membro-acesso.component').then(
            (m) => m.MembroAcessoComponent,
          ),
      },
      // {
      // path: 'entidade/:id',
      // ...rotaProtegidaPortal,
      // loadComponent: () =>
      // import('./components/entidade/entidade-edit.component').then((m) => m.EntidadeEditComponent),
      // },
      // {
      // path: 'entidade/atualizar/:id',
      // ...rotaProtegidaPortal,
      // loadComponent: () =>
      // import('./components/entidade/entidade-edit.component').then((m) => m.EntidadeEditComponent),
      // },
      {
        path: 'ferramentas',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [ACESSO_FERRAMENTAS_COLABORADOR_CEI],
          ceiGrupos: [GRUPO_COLABORADORES_CEI],
        },
        loadComponent: () =>
          import('./components/ferramentas/ferramentas.component').then((m) => m.FerramentasComponent),
      },
      {
        path: 'setores',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [ACESSO_FERRAMENTAS_COLABORADOR_CEI],
          ceiGrupos: [GRUPO_COLABORADORES_CEI],
        },
        loadComponent: () =>
          import('./components/setores/setores.component').then((m) => m.SetoresComponent),
      },
      {
        path: 'projetos',
        ...rotaProtegidaPortal,
        loadComponent: () =>
          import('./components/projetos/projeto-list/projeto-list.component').then(
            (m) => m.ProjetoListComponent,
          ),
      },
      {
        path: 'startups',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [
            ACESSO_PORTAL,
            VISUALIZAR_TODAS_ENTIDADES,
            CADASTRAR_ENTIDADES,
            ADMINISTRAR_TODAS_ENTIDADES,
          ],
          ceiGrupos: [GRUPO_ACESSO_PUBLICO_PORTAL, ADMINISTRADORES_GERAIS_ENTIDADES],
        },
        loadComponent: () =>
          import('./components/startups/startup-list.component').then(
            (m) => m.StartupListComponent,
          ),
      },
      {
        path: 'startups/nova',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [ACESSO_PORTAL, CADASTRAR_ENTIDADES, ADMINISTRAR_TODAS_ENTIDADES],
          ceiGrupos: [GRUPO_ACESSO_PUBLICO_PORTAL, ADMINISTRADORES_GERAIS_ENTIDADES],
        },
        loadComponent: () =>
          import('./components/startups/startup-detalhe.component').then(
            (m) => m.StartupDetalheComponent,
          ),
      },
      {
        path: 'startups/:id',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [
            ACESSO_PORTAL,
            VISUALIZAR_TODAS_ENTIDADES,
            CADASTRAR_ENTIDADES,
            ADMINISTRAR_TODAS_ENTIDADES,
          ],
          ceiGrupos: [GRUPO_ACESSO_PUBLICO_PORTAL, ADMINISTRADORES_GERAIS_ENTIDADES],
        },
        loadComponent: () =>
          import('./components/startups/startup-interna.component').then(
            (m) => m.StartupInternaComponent,
          ),
      },
      {
        path: 'startups/:id/editar',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [
            ACESSO_PORTAL,
            VISUALIZAR_TODAS_ENTIDADES,
            CADASTRAR_ENTIDADES,
            ADMINISTRAR_TODAS_ENTIDADES,
          ],
          ceiGrupos: [GRUPO_ACESSO_PUBLICO_PORTAL, ADMINISTRADORES_GERAIS_ENTIDADES],
        },
        loadComponent: () =>
          import('./components/startups/startup-detalhe.component').then(
            (m) => m.StartupDetalheComponent,
          ),
      },
      {
        path: 'acoes/incluir',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS, EDITAR_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS, EDITORES_PROJETOS],
        },
        loadComponent: () =>
          import('./components/projetos/acao-form/acao-form.component').then(
            (m) => m.AcaoFormComponent,
          ),
      },
      {
        path: 'acoes',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS, EDITAR_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS, EDITORES_PROJETOS],
        },
        loadComponent: () =>
          import(
            './components/projetos/acao-portal-list/acao-portal-list.component'
          ).then((m) => m.AcaoPortalListComponent),
      },
      {
        path: 'metas/incluir',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS],
        },
        loadComponent: () =>
          import('./components/projetos/meta-form/meta-form.component').then(
            (m) => m.MetaFormComponent,
          ),
      },
      {
        path: 'metas',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS, EDITAR_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS, EDITORES_PROJETOS],
        },
        loadComponent: () =>
          import(
            './components/projetos/meta-portal-list/meta-portal-list.component'
          ).then((m) => m.MetaPortalListComponent),
      },
      {
        path: 'projetos/detalhes/:id',
        ...rotaProtegidaPortal,
        loadComponent: () =>
          import('./components/projetos/projeto-detalhe/projeto-detalhe.component').then(
            (m) => m.ProjetoDetalheComponent,
          ),
      },
      {
        path: 'projetos/incluir',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS],
        },
        loadComponent: () =>
          import('./components/projetos/projeto-form/projeto-form.component').then(
            (m) => m.ProjetoFormComponent,
          ),
      },
      {
        path: 'projetos/atualizar/:id',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS],
        },
        loadComponent: () =>
          import('./components/projetos/projeto-form/projeto-form.component').then(
            (m) => m.ProjetoFormComponent,
          ),
      },
      {
        path: 'projetos/:projetoId/objetivos/incluir',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS],
        },
        loadComponent: () =>
          import('./components/projetos/objetivo-form/objetivo-form.component').then(
            (m) => m.ObjetivoFormComponent,
          ),
      },
      {
        path: 'projetos/:projetoId/objetivos/atualizar/:id',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS],
        },
        loadComponent: () =>
          import('./components/projetos/objetivo-form/objetivo-form.component').then(
            (m) => m.ObjetivoFormComponent,
          ),
      },
      {
        path: 'projetos/:projetoId/objetivos/:objetivoId/metas',
        pathMatch: 'full',
        redirectTo: ({ params }) =>
          `/projetos/detalhes/${params['projetoId']}?objetivo=${params['objetivoId']}`,
      },
      {
        path: 'projetos/:projetoId/objetivos/:objetivoId/metas/incluir',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS],
        },
        loadComponent: () =>
          import('./components/projetos/meta-form/meta-form.component').then(
            (m) => m.MetaFormComponent,
          ),
      },
      {
        path: 'projetos/:projetoId/objetivos/:objetivoId/metas/atualizar/:id',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS],
        },
        loadComponent: () =>
          import('./components/projetos/meta-form/meta-form.component').then(
            (m) => m.MetaFormComponent,
          ),
      },
      {
        path: 'projetos/:projetoId/kpis/incluir',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS],
        },
        loadComponent: () =>
          import('./components/projetos/kpi-form/kpi-form.component').then(
            (m) => m.KpiFormComponent,
          ),
      },
      {
        path: 'projetos/:projetoId/kpis/atualizar/:id',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS],
        },
        loadComponent: () =>
          import('./components/projetos/kpi-form/kpi-form.component').then(
            (m) => m.KpiFormComponent,
          ),
      },
      {
        path: 'projetos/:projetoId/acoes/incluir',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS, EDITAR_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS, EDITORES_PROJETOS],
        },
        loadComponent: () =>
          import('./components/projetos/acao-form/acao-form.component').then(
            (m) => m.AcaoFormComponent,
          ),
      },
      {
        path: 'projetos/:projetoId/acoes/atualizar/:id',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS, EDITAR_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS, EDITORES_PROJETOS],
        },
        loadComponent: () =>
          import('./components/projetos/acao-form/acao-form.component').then(
            (m) => m.AcaoFormComponent,
          ),
      },
      {
        path: 'projetos/:projetoId/objetivos/:objetivoId/metas/:metaId/acoes/incluir',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS, EDITAR_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS, EDITORES_PROJETOS],
        },
        loadComponent: () =>
          import('./components/projetos/acao-form/acao-form.component').then(
            (m) => m.AcaoFormComponent,
          ),
      },
      {
        path: 'projetos/:projetoId/objetivos/:objetivoId/metas/:metaId/acoes/atualizar/:id',
        canActivate: [autorizacaoGuard],
        data: {
          ceiPermissoes: [GESTAO_PROJETOS, EDITAR_PROJETOS],
          ceiGrupos: [GESTORES_PROJETOS, EDITORES_PROJETOS],
        },
        loadComponent: () =>
          import('./components/projetos/acao-form/acao-form.component').then(
            (m) => m.AcaoFormComponent,
          ),
      },
      {
        path: 'nao-encontrado',
        ...rotaSemAutorizacao,
        loadComponent: () =>
          import('@cei-ufg/ngx-arquitetura-cei-frontend').then((m) => m.NotFound),
        pathMatch: 'full',
      },
      {
        path: 'erro-servidor',
        ...rotaSemAutorizacao,
        loadComponent: () =>
          import('@cei-ufg/ngx-arquitetura-cei-frontend').then((m) => m.ServerError),
        pathMatch: 'full',
      },
      {
        path: 'proibido',
        ...rotaSemAutorizacao,
        loadComponent: () =>
          import('@cei-ufg/ngx-arquitetura-cei-frontend').then((m) => m.ForbiddenError),
        pathMatch: 'full',
      },
      {
        path: '**',
        ...rotaSemAutorizacao,
        redirectTo: 'nao-encontrado',
      },
    ],
  },
];
